<template>
  <el-dialog
    :title="$t('收款人名册')"
    :visible="visible"
    :close-on-click-modal="false"
    @close="handleClose"
    @opened="handleOpen"
    width="1060px"
  >
    <div class="payee-list-container">
      <el-form
        ref="payeeForm"
        :model="payeeInfo"
        :rules="rules"
        label-position="left">
        <div class="payee-list-filter">
          <el-form-item :label="$t('收款人账号') + '：'" prop="searchAccount">
            <el-input v-model="payeeInfo.searchAccount" :placeholder="$t('请输入收款人账号')" type="text" />
          </el-form-item>
          <el-form-item :label="$t('收款人户名') + '：'" prop="recAccountName">
            <el-input v-model="payeeInfo.recAccountName" :placeholder="$t('请输入收款人户名')" type="text" />
          </el-form-item>
        </div>
      </el-form>

      <div class="payee-list-filter-btns">
        <el-button class="search" @click="search">{{ $t('查询') }}</el-button>
        <el-button class="reset" @click="resetForm" type="info">{{ $t('重置') }}</el-button>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <div @click="handleClose" class="cancel">{{ $t('取消') }}</div>
      <el-button class="confirm-btn" type="primary" @click="confirmChoose">{{ $t('确定') }}</el-button>
    </span>
    <div>
      <DataTable
        v-if="visible"
        ref="table"
        :columnList="columnList"
        :data="tableData"
        max-height="355"
        @radioSelect="handleRowSelect"
      />
      <Pagination :page-size="payeeInfo.pageSize" :page-count="payeeInfo.pageNum" :total="total" @current-change="handleCurrentPageChange" />
    </div>
  </el-dialog>
</template>

<script>
import { showCustomerPayeeList } from '../api'
export default {
  props: {
    visible: { // 控制显示隐藏
      type: Boolean,
      default: false
    },
    recBankType: {
      type: String,
      default: ''
    },
    rmtType: {
      type: String,
      default: ''
    },
    payeeType: {
      type: String,
      default: ''
    }
  },

  created () {
    this.getTableList()
  },

  data () {
    return {
      payeeInfo: { // 筛选
        searchAccount: '', // 收款方账号
        recAccountName: '', // 收款方户名
        pageSize: 10,
        pageNum: 1
      },
      total: 0,
      columnList: [
        { label: '', type: 'radio', width: '40px' },
        { label: '收款人账号', prop: 'recAccount' },
        { label: '收款人户名', prop: 'recAccountName' },
        { label: 'SWIFT代码', prop: 'bankSwift' },
        { label: '收款人地址', prop: 'agencyBankAddress', width: '375px' }
      ],
      tableData: [],
      currentSelectRow: null
    }
  },
  computed: {
    rules () {
      return { // 校验规则
        searchAccount: { required: true, message: this.$t('请输入收款人账号'), trigger: 'blur' },
        recAccountName: { required: true, message: this.$t('请输入收款人名称'), trigger: 'blur' }
      }
    }

  },
  methods: {
    // 确定选择
    confirmChoose () {
      if (!this.currentSelectRow) {
        this.handleClose()
        return
      }
      // 获取table的选项
      this.$emit('updatePayeeInfo', this.currentSelectRow)
    },
    handleCurrentPageChange (currentPage) {
      this.payeeInfo.pageNum = currentPage
      this.getTableList()
    },
    getTableList () {
      const { recBankType, payeeType } = this.$props
      return showCustomerPayeeList({
        recBankType,
        payeeType,
        currentBusinessCode: '10200500',
        ...this.payeeInfo,
        pageSize: this.payeeInfo.pageSize,
        pageNum: this.payeeInfo.pageNum
        // commonPayee: 1
      }).then(res => {
        this.tableData = res.list
        this.total = res.totalSize
      })
    },
    // 查询
    search () {
      this.$refs.payeeForm.validate(valid => {
        if (valid) {
          this.payeeInfo.pageNum = 1
          this.getTableList()
        }
      })
    },
    // 单选按钮选择时
    handleRowSelect (item) {
      this.currentSelectRow = item
    },
    // 重置
    resetForm () {
      this.$refs.payeeForm.resetFields()
      this.payeeInfo.pageSize = 10
      this.payeeInfo.pageNum = 1
      this.getTableList()
    },
    handleOpen () {
      this.getTableList()
    },
    // 关闭弹窗回调
    handleClose () {
      this.currentSelectRow = null
      this.$refs.payeeForm.resetFields()
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="less" scoped>
  .dialog-footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .cancel {
      min-width: 70px;
      padding: 0 20px;
      margin-right: 20px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      color: #4A6AFF;
      font-size: 14px;

      &:hover {
        color: @blueLess60;
      }
    }
  }
  .confirm-btn {
    min-width: 140px;
  }
  .payee-list-container {

    .payee-list-filter-btns {
      margin: 10px 0 30px;
      display: flex;

      .search, .reset {
        min-width: 140px;
      }
    }

    .payee-list-filter {
      display: flex;

      .el-form-item {
        flex: 1 1 0%;

        &:nth-child(1) {
          margin-right: 40px;
        }
      }
    }
  }
</style>
